import type { PointerEvent as ReactPointerEvent } from "react";
import { cn } from "@/lib/utils";
import { useAssistantDock } from "../store";

// Alça de resize na borda interna do dock (só no lg, onde o dock é dimensionado; no
// mobile é overlay). Tamanho derivado da posição absoluta do ponteiro (robusto a acúmulo de delta).
// Só existe nos modos ANCORADOS — o prop é o literal narrowo (floating não tem alça).
const LIMITS = { right: { min: 320, max: 720 }, bottom: { min: 240, max: 600 } } as const;

export function ResizeHandle({ mode }: { mode: "right" | "bottom" }) {
  const setSize = useAssistantDock((s) => s.setSize);

  function onPointerDown(e: ReactPointerEvent) {
    e.preventDefault();
    const move = (ev: PointerEvent) => {
      const raw =
        mode === "right" ? window.innerWidth - ev.clientX : window.innerHeight - ev.clientY;
      setSize(Math.max(LIMITS[mode].min, Math.min(LIMITS[mode].max, raw)));
    };
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  }

  return (
    <div
      role="separator"
      aria-label="Redimensionar o painel"
      onPointerDown={onPointerDown}
      className={cn(
        "absolute z-10 hidden transition-colors hover:bg-primary/30 lg:block",
        mode === "right"
          ? "inset-y-0 left-0 w-1 cursor-ew-resize"
          : "inset-x-0 top-0 h-1 cursor-ns-resize"
      )}
    />
  );
}
